import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Router from 'next/router';
import { twMerge } from 'tailwind-merge';
import { faMapPin } from '@soundxyz/font-awesome/pro-solid-svg-icons/index.mjs';
import type { Maybe } from '@soundxyz/utils';
import { EXPLORE_TYPES } from '@components/Explore/schema';
import { SortOrder } from '@graphql/reactQuery';
import { NAV_LINKS } from '@utils/constants';

export const Location = ({
  location,
}: {
  location: Maybe<{
    label: string;
    placeId: string;
  }>;
}) => {
  if (!location) return null;

  return (
    <button
      className={twMerge(
        'flex items-center gap-1.5 capitalize transition-[filter] duration-300 hover:brightness-[70%]',
        'whitespace-nowrap font-base text-base-m font-medium leading-6 text-base400',
      )}
      onClick={() => {
        Router.push({
          pathname: NAV_LINKS.Explore,
          query: {
            explore_type: EXPLORE_TYPES.SOUNDS,
            total_volume: SortOrder.Desc,
            search_location_label: location.label,
            search_location_place_id: location.placeId,
          },
        });
      }}
    >
      <FontAwesomeIcon icon={faMapPin} />
      <p>{location.label}</p>
    </button>
  );
};
